export default "__VITE_ASSET__A2$WGb9N__"